import { CheckCircleFilled } from '@ant-design/icons';
import { Button } from 'antd';
import FormSuccess from 'components/FormSuccess';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { RAI } from 'types/Concessionnaire';

interface Props {
  rai?: RAI;
  isPersonnePhysique: boolean;
  onCloseSuccess: () => void;
}

export default function Success({
  rai,
  isPersonnePhysique,
  onCloseSuccess,
}: Props) {
  const { t } = useTranslation();

  if (isPersonnePhysique) {
    return (
      <FormSuccess
        title={t('nouveau_formulaire:success:isPersonnePhysique:title')}
        className="whitespace-pre-wrap"
        onCloseSuccess={onCloseSuccess}
      >
        {t('nouveau_formulaire:success:isPersonnePhysique:text')}
      </FormSuccess>
    );
  }

  if (rai === '3.1') {
    return (
      <div className="w-full md:max-w-[690px]">
        <div className="rounded-2xl bg-vert-transport-1 px-8 py-10">
          <p className="mb-2 flex items-center gap-3 text-vert-agriculture-8">
            <CheckCircleFilled className="" />
            <span>{t('nouveau_formulaire:success:3.2:title')}</span>
          </p>

          <p className="whitespace-pre-wrap pl-7 text-gris-hellio-6/85">
            {t('nouveau_formulaire:success:3.2:text')}
          </p>
        </div>

        <div className="mt-8 flex justify-center">
          <Button
            type="primary"
            size="large"
            shape="round"
            onClick={onCloseSuccess}
          >
            {t('global:back_home')}
          </Button>
        </div>
      </div>
    );
  }

  if (rai === '3.2') {
    const steps = [
      'nouveau_formulaire:success:3.1:steps:item_1',
      'nouveau_formulaire:success:3.1:steps:item_2',
      'nouveau_formulaire:success:3.1:steps:item_3',
      'nouveau_formulaire:success:3.1:steps:item_4',
    ];

    return (
      <div className="w-full md:max-w-[680px]">
        <p className="mb-6 flex items-center gap-3  text-vert-agriculture-8">
          <CheckCircleFilled className="text-[24px]" />
          <span>{t('nouveau_formulaire:success:3.1:confirmation')}</span>
        </p>

        <h2 className="mb-2 text-gris-hellio-6">
          {t('nouveau_formulaire:success:3.1:next_steps')}
        </h2>

        <ol className="mb-8 space-y-4 rounded-xl bg-bleu-hellio-1 p-6">
          {steps.map((step, idx) => (
            <li key={step} className="flex items-start gap-3">
              <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-bleu-hellio">
                <span className="text-white">{idx + 1}</span>
              </span>

              <div className="text-base text-gris-hellio-6">
                <Trans i18nKey={step} key={step}>
                  <strong className="font-semibold" />
                </Trans>
              </div>
            </li>
          ))}
        </ol>

        <div className="flex justify-center">
          <Button
            type="primary"
            size="large"
            shape="round"
            onClick={onCloseSuccess}
          >
            {t('global:back_home')}
          </Button>
        </div>
      </div>
    );
  }

  return null;
}
